'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _actionTypes = require('./action-types');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

var _linksoftAlbatros = require('linksoft-albatros');

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

var _emailingApi = require('./emailingApi');

var _emailingApi2 = _interopRequireDefault(_emailingApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    isCompact: false,
    step: 1,
    processing: false,
    items: [],
    giftItems: [],
    changes: {},
    updating: {},
    id: null,
    totalPriceWithoutVat: 0,
    totalPriceWithVat: 0,
    totalVat: 0,
    dispatchSeparately: false,
    note: null,
    noteError: null,
    processingOrdersPrice: 0,
    minPriceForDispatch: 0,
    maxAmountPerItem: 0,
    canCreateOrder: false,
    canChangeCart: false,
    dispatchWarning: false,
    offlineMode: false,
    offlineModeMessage: null,
    sendOrderDisabledReason: null,
    showStockAmountSeparately: false,
    notifyMessages: [],
    amountAvailableLimit: 0,

    changedOptions: {},
    optionsVersion: 0,
    savedOptionsVersion: 0,
    savingOptionsVersion: null,
    customerChangeRoundtrip: false,
    midCartVisibility: false,
    couponRefusedReason: null
};

function numbersOnly(value) {
    if (typeof value !== 'string') value = '';
    return value.replace(/\D/g, '');
}

function getNumber(value) {
    if (typeof value === 'number') return value;
    if (typeof value !== 'string') value = null;
    value = parseInt(value, 10);
    if (isNaN(value)) {
        value = null;
    }
    return value;
}

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var newState = state;
    switch (action.type) {
        case _actionTypes2.default.SETTING_COUPON:
            newState = (0, _extends3.default)({}, state, { settingCoupon: true });
            break;
        case _actionTypes2.default.COUPON_SET:
            newState = (0, _extends3.default)({}, state, { couponRefusedReason: action.couponRefusedReason, settingCoupon: false });
            break;
        case _actionTypes2.default.ORDERING:
            newState = (0, _extends3.default)({}, state, { sendingOrder: true });
            break;
        case _actionTypes2.default.ORDER_FAILED:
            newState = (0, _extends3.default)({}, state, { sendingOrder: false });
            break;

        case _actionTypes2.default.CHANGE_STEP:
            newState = (0, _extends3.default)({}, state, { step: action.step });
            break;

        case _actionTypes2.default.ADD_BY_EAN:
            newState = (0, _extends3.default)({}, state, { addByEan: { ean: action.ean, amount: action.amount } });
            break;

        case _actionTypes2.default.UPDATE:
        case _actionTypes2.default.DELIVERY_CHANGE:
        case _actionTypes2.default.PAYMENT_CHANGE:
        case _actionTypes2.default.FREE_PRODUCT_SET:
            {
                newState = (0, _extends3.default)({}, state, { processing: false, updating: {} }, action.cart);
                if (Array.isArray(newState.notifyMessages)) {

                    var messages = [].concat((0, _toConsumableArray3.default)(newState.notifyMessages));
                    if (newState.showMessagesAsPopup && messages.length > 0) {
                        var firstMessage = messages.shift(1);
                        _message2.default.warn(firstMessage);
                        newState.notifyMessages = messages;
                    }
                    messages.forEach(function (v) {
                        return _abp2.default.notify.warn(v);
                    });
                }
                _emailingApi2.default.updateCart(newState.items);
                break;
            }
        case _actionTypes2.default.CHANGE_AMOUNT:
            {
                newState = (0, _merge2.default)({}, state);
                var maxAmount = state.maxAmountPerItem || 0;
                var origAmountInt = action.origAmount || (state.items.find(function (i) {
                    return i.productId === action.productId;
                }) || {}).amount || null;
                var origAmount = origAmountInt === null ? '' : origAmountInt + '';
                var newAmount = numbersOnly(action.amount);
                var newAmountInt = getNumber(newAmount);
                if (newAmountInt <= maxAmount || newAmountInt < origAmountInt) {
                    if (newAmount === origAmount) {
                        delete newState.changes[(0, _linksoftAlbatros.getCartChangeKey)(action)];
                    } else {
                        newState.changes[(0, _linksoftAlbatros.getCartChangeKey)(action)] = {
                            productId: action.productId,
                            giftId: action.giftId,
                            amount: newAmountInt,
                            displayAmount: newAmount,
                            processing: false
                        };
                    }
                }
                break;
            }
        case _actionTypes2.default.LOAD_DATA:
            newState = (0, _assign2.default)({}, state, { processing: true });
            break;

        case _actionTypes2.default.SUBMIT_CHANGES:
            newState = (0, _merge2.default)({}, state, { processing: true });
            newState.changes = (0, _extends3.default)({}, newState.changes);
            newState.updating = (0, _extends3.default)({}, newState.updating);

            action.items.map(function (i) {
                return { key: (0, _linksoftAlbatros.getCartChangeKey)(i), item: i };
            }).forEach(function (x) {
                var change = newState.changes[x.key];
                if (!change) {
                    change = { productId: x.item.productId };
                } else {
                    delete newState.changes[x.key];
                }
                newState.updating[x.key] = change;
            });
            break;

        case _actionTypes2.default.UPDATE_FAILED:
            newState = (0, _assign2.default)({}, state, { processing: false, changes: {}, updating: {} });
            break;

        case _actionTypes2.default.OPTIONS_CHANGED:
            newState = (0, _extends3.default)({}, state, { changedOptions: (0, _extends3.default)({}, state.changedOptions, action.options), optionsVersion: state.optionsVersion + 1 });
            break;
        case _actionTypes2.default.OPTIONS_SAVING:
            newState = (0, _extends3.default)({}, state, { savingOptionsVersion: action.version });
            break;
        case _actionTypes2.default.OPTIONS_SAVING_FAILED:
            newState = (0, _extends3.default)({}, state, { savingOptionsVersion: null, changedOptions: {} });
            break;
        case _actionTypes2.default.OPTIONS_SAVED:
            {
                var changedOptions = state.optionsVersion !== action.version ? state.changedOptions : {};
                newState = (0, _extends3.default)({}, state, { savedOptionsVersion: action.version, savingOptionsVersion: null, changedOptions: changedOptions });
                break;
            }
        case _actionTypes2.default.CUSTOMER_CHANGE_ROUNDTRIP:
            newState = (0, _extends3.default)({}, state, { customerChangeRoundtrip: true });
            break;

        case _actionTypes2.default.CHANGE_NOTE:
            {
                newState = (0, _extends3.default)({}, state, { note: action.note, noteError: action.noteError });
                break;
            }
        case _actionTypes2.default.SET_PROCESSING:
            {
                newState = (0, _extends3.default)({}, state, { processing: action.processing });
                break;
            }
        case _actionTypes2.default.MID_CART_VISIBILITY:
            {
                newState = (0, _extends3.default)({}, state, { midCartVisibility: action.midCartVisibility });
                break;
            }

    }
    return newState;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/reducer.js
// module id = 1041
// module chunks = 0